<template>
  <v-card v-if="isSDECC == 1" class="auth-basic-info pa-3">
    <v-card-title class="pb-0">
      <h2>
        {{
          me && me.type === 'student'
            ? 'Update your Username or Email'
            : 'Update your Email'
        }}
      </h2>
      <p>
        {{
          me && me.type === 'student'
            ? 'Update your Username or Email'
            : 'Update your Email'
        }}
        here.
      </p>
    </v-card-title>
    <v-card-text v-if="me">
      <v-text-field
        v-if="cloneMe"
        v-model="cloneMe.email"
        v-validate="'required|max:150'"
        :error-messages="errors.collect('email')"
        :label="me && me.type === 'student' ? 'Username or E-mail' : 'E-mail'"
        data-vv-name="email"
        :data-vv-as="
          me && me.type === 'student' ? 'username or email' : 'email'
        "
        required
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="primary"
        @click="submit"
        :loading="loading"
        :disabled="disabled"
        class="button_google_tag_manager"
        data-category="user"
        data-action="click"
        data-label="update profile"
      >
        Update
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Auth from '@/modules/auth/models/Auth'
import { mapMutations } from 'vuex'

export default {
  name: 'CredentialInfo',
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      loading: false,
      cloneMe: {},
      isSDECC: 0
    }
  },
  computed: {
    me() {
      let type = this.$route.meta.type
      if (type == 'user') type = 'student'
      return Auth.query()
        .where('type', type)
        .first()
    },
    disabled() {
      if (!this.cloneMe || !this.me) {
        return true
      }
      if (this.loading) {
        return true
      }
      if (this.cloneMe.email === this.me.email) {
        return true
      }
      return false
    }
  },
  watch: {
    me() {
      this.cloneMe = {
        email: this.me.email
      }
    }
  },
  mounted() {
    if (this.me) {
      this.cloneMe = {
        email: this.me.email
      }
    }

    if (this.$store.state.isSDECC == 1) {
      this.isSDECC = 1
    } else this.isSDECC = 0
  },
  methods: {
    ...mapMutations('snackbar', ['showErrorSnackbar', 'showSnackbar']),
    async submit() {
      // validate form
      let result = await this.$validator.validateAll()

      if (!result) return // there are errors

      try {
        this.loading = true

        await Auth.dispatch('updateProfile', {
          payload: {
            email: this.cloneMe.email
          },
          type: `${this.me.type}s`
        })
        this.loading = false
        this.showSnackbar('Credentials updated successfully.')
      } catch (error) {
        this.loading = false
        this.showErrorSnackbar('There was an error.')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.auth-basic-info {
  h2 {
    display: block;
    width: 100%;
    font-size: 1em;
  }

  p {
    padding: 0;
    margin: 0;
    font-size: 1rem;
  }
}
</style>
